import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Box } from "@mui/material";
import type { JSX } from "react";

import { ValuationHubCoreModelImage } from "@/api/generatedApi";
import { ImageCard } from "@/components/imageCard";

interface SortableImageCardProps {
  image: ValuationHubCoreModelImage;
  index: number;
  chip?: string;
  isPending?: boolean;
  isTitlePicture?: boolean;
  onDelete: (imageId: string) => void;
  onTitleChange?: (imageId: string, newTitle: string) => void;
  minHeight?: string;
  maxHeight?: string;
  readonly?: boolean;
}

export const SortableImageCard = ({
  image,
  index,
  chip,
  isPending,
  isTitlePicture,
  onDelete,
  onTitleChange,
  minHeight,
  maxHeight,
  readonly,
}: SortableImageCardProps): JSX.Element => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: image.id ?? "" });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0 : 1,
    position: "relative" as const,
  };

  return (
    <Box ref={setNodeRef} style={style} {...attributes}>
      <ImageCard
        image={image}
        index={index}
        chip={chip}
        isPending={isPending}
        isTitlePicture={isTitlePicture}
        onDelete={onDelete}
        onTitleChange={onTitleChange}
        dragHandleProps={readonly ? undefined : listeners}
        minHeight={minHeight}
        maxHeight={maxHeight}
        readonly={readonly}
      />
    </Box>
  );
};
